/**
 * V7 task urgency from a task's own words: the one rule the phone, the console and the server's
 * ladder use when a task carries no level of its own. Pure and dependency free, so the server
 * can import this file or keep a parity test against it.
 *
 * The ladder moves an urgent task every 2 minutes, so a wrong URGENT pages the charge and on-call
 * nurses for nothing. Only an actual event is urgent. A scheduled round, check or reposition is
 * routine even when its name says "fall" ("Fall-risk round"), unless it also names an event.
 */
export type TaskUrgency = 'urgent' | 'soon' | 'routine';

/** An event happening now: a fall, a call button, chest pain, choking, wandering, an emergency. */
export const URGENT_EVENT = /\b(fell|fallen|has fallen|fall detected|possible fall|on the floor|call button|call light|chest pain|choking|wander(?:ing|ed)?|elopement|emergency|ca[ií]da|se cay[oó])\b/i;
/** The design's urgent words (care-flow.js levelOf). */
export const URGENT_WORDS = /fall|call button|bathroom|chest|pain|choking|wander|emergency|ca[ií]da/i;
/** Scheduled work: never urgent on its words alone. */
export const SCHEDULED_WORK = /\b(round|rounds|ronda|check|checks|checklist|reposition|repositioning|turn|turning|risk|screen|screening|assessment)\b/i;
/** The design's soon words. */
export const SOON_WORDS = /med|prn|dose|family|insulin|water|drink|vital/i;

export function taskUrgencyFromText(text: string): TaskUrgency {
  const t = text || '';
  if (URGENT_EVENT.test(t)) return 'urgent';
  if (SCHEDULED_WORK.test(t)) return SOON_WORDS.test(t) ? 'soon' : 'routine';
  if (URGENT_WORDS.test(t)) return 'urgent';
  if (SOON_WORDS.test(t)) return 'soon';
  return 'routine';
}
